import { createFileRoute } from '@tanstack/react-router'
import { Container, Eyebrow, Wordmark } from '@/components/landing/primitives'

export const Route = createFileRoute('/thank-you')({
  component: ThankYou,
  head: () => ({
    meta: [
      { title: 'Welcome to Vello' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
})

function ThankYou() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header style={{ padding: '24px 0', borderBottom: '1px solid var(--line)' }}>
        <Container>
          <Wordmark />
        </Container>
      </header>
      <main style={{ flex: 1, padding: '120px 0' }}>
        <Container>
          <div style={{ maxWidth: 680 }}>
            <Eyebrow>Intake received</Eyebrow>
            <h1
              style={{
                fontFamily: 'var(--serif)',
                fontSize: 'clamp(40px, 6vw, 72px)',
                lineHeight: 1.0,
                letterSpacing: '-0.025em',
                fontWeight: 400,
                margin: '20px 0 0',
              }}
            >
              You&rsquo;re all set.
            </h1>
            <p
              style={{
                fontSize: 18,
                lineHeight: 1.55,
                color: 'var(--muted)',
                marginTop: 24,
                maxWidth: 560,
              }}
            >
              Thanks. Everything needed is in. Your site kicks off now. Confirmation
              email on its way. First design round lands on day three.
            </p>
            <div
              style={{
                marginTop: 40,
                padding: 24,
                border: '1px solid var(--line-strong)',
                background: '#fff',
                borderRadius: 4,
                maxWidth: 560,
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--mono)',
                  fontSize: 12,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'var(--muted)',
                  marginBottom: 12,
                }}
              >
                What happens next
              </div>
              <ol
                style={{
                  margin: 0,
                  paddingLeft: 20,
                  fontSize: 15,
                  lineHeight: 1.7,
                  color: 'var(--fg)',
                }}
              >
                <li>Confirmation email in your inbox in a few minutes.</li>
                <li>Day 3: first design round for your review.</li>
                <li>Day 7: site live on your domain.</li>
              </ol>
            </div>
            <p
              style={{
                fontSize: 14,
                color: 'var(--muted)',
                marginTop: 32,
                fontFamily: 'var(--mono)',
                letterSpacing: '0.04em',
              }}
            >
              Questions?{' '}
              <a
                href="mailto:hello@withvello.com"
                style={{ borderBottom: '1px solid var(--line-strong)' }}
              >
                hello@withvello.com
              </a>
            </p>
          </div>
        </Container>
      </main>
    </div>
  )
}
